














































































































































import {EntityService} from "@/services/entity.service";
import Vue from "vue";
import New from './New.vue'
import Edit from './Edit.vue'
import {mapState} from "vuex";
const entityService = new EntityService()

export default Vue.extend({
	name: 'List',
	components: { New, Edit },
	data: () => ({
		isLoading: false,
		entity: 'audios',
		search: '',
		listData: [],
		headers: [
			{ text: 'ID', value: 'id' },
			{
				text: 'Título',
				align: 'start',
				value: 'name',
			},
			{ text: 'Duración', value: 'duration' },
			{ text: 'Estado', value: 'status' },
			{ text: 'Resultado', value: 'result' },
			{ text: 'Fecha Creación', value: 'createdAt' },
			{ text: '', value: 'actions' }
		],
		showArchived: false,
		showModalNew: false,
		showModalEdit: false,
		showModalResult: false,
		selectedResult: '',
		editEntity: {}
	}),
	async created() {
		this.loadData()
	},
	computed: {
		...mapState(["user"])
	},
	methods: {
		async loadData() {
			this.isLoading = true
			this.listData = await entityService.getList(this.showArchived ? `${this.entity}/archived` : this.entity)
			this.isLoading = false
		},
		getStatusLabelColor(status: string) {
			switch (status) {
				case 'pending':
					return {label: 'Pendiente', color: 'warning'}
				case 'working':
					return {label: 'En proceso', color: 'info'}
				case 'success':
					return {label: 'Finalizado', color: 'success'}
				case 'fail':
					return {label: 'Error convirtiendo', color: 'error'}
				default:
					return {label: '', color: ''}
			}
		},
		editEntityAction (entity: object) {
			this.editEntity = entity
			this.showModalEdit = true
		},
		async transcribe(id: number) {
			this.isLoading = true
			await entityService.makeEntityAction(this.entity, id, 'transcribe')
			await this.loadData()
		},
		async pay(id: number) {
			// this.isLoading = true
			try {
				const epaycoData = await entityService.makeEntityAction(this.entity, id, 'pay')
				const handler = window['ePayco'].checkout.configure({
					key: '3b8fae23c8f621fdd4241f25f2549c23',
					test: true
				})
				handler.open(epaycoData)
			} catch (e) {
				alert(e.message)
			}
		},
		async result(id: number) {
			this.isLoading = true
			try {
				const result = await entityService.makeEntityAction(this.entity, id, 'result')
				this.selectedResult = result.result
				this.showModalResult = true
			} catch (e) {
				alert(e.message)
			}
			this.isLoading = false
		},
	},
	watch: {
		showModalNew (value) {
			if (!value) this.loadData()
		},
		showModalEdit (value) {
			if (!value) this.loadData()
		}
	}
})
